var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"navbar",attrs:{"mode":"horizontal"}},[_c('breadcrumb')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }